import * as React from "react"
import { SelectSeeker, ButtonIconSeeker } from "@ui-seeker/core";
import { Box } from "@mui/material";
import { useToast } from "@hooks"
import {BACKEND_APIS, DATE_METRICS} from "@constants";
import {commonFiltersValue, metric} from "@signals";
import {MetricSelect} from "../../../../../@components";
import {isLoadingMetric} from "../../@signals";


const OPTIONS = [
	{ label: 'By Users', value: 'users' },
	{ label: 'By Dashboards', value: 'dashboards' },
	{ label: 'By Submits', value: 'submits' }
]

const METRIC_OPTIONS = [
	{ label: 'Daily', value: DATE_METRICS.DAILY },
	{ label: 'Weekly', value: DATE_METRICS.WEEKLY },
	{ label: 'Monthly', value: DATE_METRICS.MONTHLY },
	{ label: 'Quarterly', value: DATE_METRICS.QUARTERLY }
]

export default function UserActivitiesEvolutionActions({ value, onChange, onDownload }) {
	const { showToast } = useToast()
    const handleClick = () => {
        showToast.promiseExcel(`${BACKEND_APIS.ADMIN}/user-activities/evolution/${value}/excel`, {...commonFiltersValue.value, activitySelected: value}, null, {
			onError: data => {
				if (data.toString().includes('Error')) return 'Excel file size exceeded'
			}
		})
    }

    return <Box sx={{ display: 'flex', minWidth: 400 }}>
		<SelectSeeker
			label="Kpi"
			options={OPTIONS}
			value={value}
			onChange={onChange}
			sx={{ mr: 1 }}
		/>

		<Box>
			<MetricSelect
            fullWidth={false}
            sx={{ width: 200, mr: 1.5 }}
            value={metric.value}
			options={METRIC_OPTIONS}
            onChange={(e) => {
				isLoadingMetric.value = true
				metric.value = e.target.value
			}}
        />
		</Box>

		<ButtonIconSeeker
			icon="download"
			tooltip="Download Excel"
			onClick={handleClick}
		/>
	</Box>
}